import fastDeepEqual from 'fast-deep-equal';

// This allows for comparison of oneOf values, for which '!type' is optional (it's returned in API responses, but is not used in requests)
function recursivelyRemoveTypeValue<T>(value: T): T {
  if (typeof value !== 'object' || value === null) {
    return value;
  }

  if (Array.isArray(value)) {
    return value.map(recursivelyRemoveTypeValue) as T;
  }

  const newValue: Partial<T> = {};
  for (const [key, val] of Object.entries(value)) {
    if (key !== '!type') {
      newValue[key as keyof T] = recursivelyRemoveTypeValue(val);
    }
  }

  return newValue as T;
}

export function isDeepEqual<T>(a: T | undefined, b: T | undefined): boolean {
  if ((a && !b) || (!a && b)) {
    return false;
  }

  if (typeof a === 'object' || typeof b === 'object') {
    return fastDeepEqual(recursivelyRemoveTypeValue(a), recursivelyRemoveTypeValue(b));
  }

  return a === b;
}
